import React, { Component } from "react";
import View from './views';
import API from '../../requests';
import { DiagnosticId } from '../../enums';
import { connect } from 'react-redux';
import { reactivateDeviceAction } from '../../store/actions';
import { getPopupConfig } from "../../components/Popup";
import util from '../../util';
import FireboardUtils from '../../util/fireboard-util';
import { version } from '../../../package.json';

const pingURL = 'https://www.google.com';

class Diagnostics extends Component {
  state = {
    popup: undefined,
    table: [
      {
        id: DiagnosticId.NETWORK_PING,
        test: 'Network',
        value: 'Running',
        result: 'pending',
      },
      {
        id: DiagnosticId.OD_PING,
        test: 'OneDine',
        value: 'Running',
        result: 'pending',
      },
      {
        id: DiagnosticId.SYNC,
        test: 'Server Sync',
        value: 'Running',
        result: 'pending',
      },
      {
        id: DiagnosticId.OMNIVORE_STORE_STATUS,
        test: 'Omnivore',
        value: 'Running',
        result: 'pending',
      },
      {
        id: DiagnosticId.OMNIVIRE_HEALTHY,
        test: 'Omnivore health',
        value: 'Running',
        result: 'pending',
      },
      {
        id: DiagnosticId.POS_SYSTEM_STATUS,
        test: 'POS System',
        value: 'Running',
        result: 'pending',
      },
      {
        id: DiagnosticId.DEVICE_ACTIVATION,
        test: 'Device activated',
        value: 'Running',
        result: 'pending',
      },
      // {
      //   id: DiagnosticId.DEVICE_STATUS,
      //   test: strings.deviceStatus,
      //   value: deviceDiagnosticsConstants.RUNNING,
      //   result: strings.testPending,
      // },
    ],
    inputText: '',
  };

  componentDidMount() {
    const {
      history,
      reduxProps: { storeInfo, deviceInfo },
    } = this.props;

    if (!storeInfo.data || !deviceInfo.deviceExternalId) {
      history.push("/");
      return;
    }
    this.load();
  }

  // eslint-disable-next-line react/sort-comp
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.handleReactivateDevice(nextProps);
  }

  handleReactivateDevice = ({ reduxProps }) => {
    const { reduxProps: prevReduxProps, history } = this.props;
    const { reactivateDevice } = reduxProps;
    if (reactivateDevice.timestamp !== prevReduxProps.reactivateDevice.timestamp) {
      if (reactivateDevice.isFetching) {
        const popup = getPopupConfig('spinner');
        popup.heading = 'Reactivating device';
        this.setState({ popup });
      } else if (reactivateDevice.data) {
        if (window.ReactNativeWebView) {
          history.push({
            pathname: '/',
            state: { reactivate: true }
        });
        } else {
          history.push("/");
        }
      } else {
        const popup = getPopupConfig('error', () => {
          this.setState({ popup: undefined });
        });
        popup.message = reactivateDevice.error.erroMessage;
        this.setState({ popup });
      }
    }
  };

  load = () => {
    this.getNetworkPing();
    this.getOneDinePing();
    // this.getDeviceStatus();
  };

  closePopup = () => {
    this.setState({ popup: undefined });
  }

  stateSetter = object => {
    this.setState(prevState => ({
      table: prevState.table.map(row => {
        if (row.id === object.id) {
          return { ...object };
        }
        return row;
      }),
    }));
  };

  getNetworkPing = () => {
    const start = new Date().getTime();
    API.pingURL(pingURL)
      .then((response) => {
        FireboardUtils.addNetworkLogs(response);
        this.stateSetter({
          id: DiagnosticId.NETWORK_PING,
          test: 'Network',
          value: `Online (${new Date().getTime() - start} ms)`,
          result: 'pass',
        });
      })
      .catch(error => {
        console.info('error', error);
        FireboardUtils.addNetworkLogs(error.response);
        this.stateSetter({
          id: DiagnosticId.NETWORK_PING,
          test: 'Network',
          value: 'Offline',
          result: 'fail',
        });
      });
  };

  getOneDinePing = () => {
    const start = new Date().getTime();
    const {
      reduxProps: {
        deviceApi,
      },
    } = this.props;
    const { deviceId } = deviceApi?.data;
    API.pingOneDine(deviceId)
      .then(response => {
        FireboardUtils.addNetworkLogs(response);
        console.debug('pingOneDine response', response);
        this.stateSetter({
          id: DiagnosticId.DEVICE_ACTIVATION,
          test: 'Device activated',
          value: response.data.activationOnline ? 'Online' : 'Offline',
          result: response.data.activationOnline ? 'pass' : 'fail',
        });
        this.stateSetter({
          id: DiagnosticId.OD_PING,
          test: 'OneDine',
          value: response.data.oneDineOnline
            ? `Online (${new Date().getTime() - start} ms)`
            : 'Offline',
          result: response.data.oneDineOnline ? 'pass' : 'fail',
        });
        this.stateSetter({
          id: DiagnosticId.SYNC,
          test: 'Server Sync',
          value: response.data.syncOnline
            ? `Online (${new Date().getTime() - start} ms)`
            : 'Offline',
          result: response.data.syncOnline ? 'pass' : 'fail',
        });
        this.stateSetter({
          id: DiagnosticId.OMNIVORE_STORE_STATUS,
          test: 'Omnivore',
          value: response.data.omnivoreOnline ? 'Online' : 'Offline',
          result: response.data.omnivoreOnline ? 'pass' : 'fail',
        });
        this.stateSetter({
          id: DiagnosticId.POS_SYSTEM_STATUS,
          test: 'POS System',
          value: response.data.posOnline ? 'Online' : 'Offline',
          result: response.data.posOnline ? 'pass' : 'fail',
        });
        const { omnivoreOnline, omnivoreHealthy } = response.data;
        const { value, result } = this.getHealth(omnivoreOnline, omnivoreHealthy);
        this.stateSetter({
          id: DiagnosticId.OMNIVIRE_HEALTHY,
          test: 'Omnivore health',
          value,
          result,
        });
      })
      .catch(error => {
        console.warn('pingOneDine error', error);
        FireboardUtils.addNetworkLogs(error.response);
        this.stateSetter({
          id: DiagnosticId.DEVICE_ACTIVATION,
          test: 'Device activated',
          value: 'Offline',
          result: 'fail',
        });
        this.stateSetter({
          id: DiagnosticId.OD_PING,
          test: 'OneDine',
          value: 'Offline',
          result: 'fail',
        });
        this.stateSetter({
          id: DiagnosticId.SYNC,
          test: 'Server Sync',
          value: 'Offline',
          result: 'fail',
        });
        this.stateSetter({
          id: DiagnosticId.OMNIVORE_STORE_STATUS,
          test: 'Omnivore',
          value: 'Offline',
          result: 'fail',
        });
        this.stateSetter({
          id: DiagnosticId.POS_SYSTEM_STATUS,
          test: 'POS System',
          value: 'Offline',
          result: 'fail',
        });
        this.stateSetter({
          id: DiagnosticId.OMNIVIRE_HEALTHY,
          test: 'Omnivore health',
          value: 'Offline',
          result: 'fail',
        });
      });
  };

  // getDeviceStatus = () => {
  //   if (Platform.OS === 'android') {
  //     GatewayService.deviceStatus()
  //       .then(response => {
  //         this.updateDeviceStatus(JSON.parse(response));
  //       })
  //       .catch(error => console.warn('getDeviceStatus Error:', error));
  //   } else {
  //     this.updateDeviceStatus({
  //       deviceState: deviceDiagnosticsConstants.DEVICE_CONNECTING,
  //     });
  //   }
  // };

  onBtnPress = (type, value) => {
    switch (type) {
      case 'reload': {
        this.load();
        break;
      }
      case 'reactivate': {
        this.setState({ popup: { type: 'reactivate' } });
        break;
      }
      case 'done': {
        const { reduxProps: { deviceInfo }, dispatchReactivateDevice } = this.props;
        // TODO: Remove uuid hardcoded
        dispatchReactivateDevice({
          latitude: 0,
          longitude: 0,
          activationCode: value.code,
          uuid: null,
          deviceExternalId: deviceInfo.deviceExternalId,
          appVersion: version,
        });
      }
    }
  }

  getProps = () => {
    const { history, dismissPopup, isComponent } = this.props;
    const { table, popup } = this.state;
    return {
      tableData: table,
      history,
      popup,
      onPress: this.onBtnPress,
      closePopup: this.closePopup,
      dismissPopup,
      isComponent,
    };
  }

  render() {
    const viewProps = this.getProps();
    return <View {...viewProps} />;
  }
}
const mapStateToProps = reduxProps => ({
  reduxProps,
});

const mapDispatchToProps = dispatch => ({
  dispatchReactivateDevice: payload => {
    dispatch(reactivateDeviceAction(payload));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Diagnostics);
